<template>
  <div class="content-block">
    <vue-mathjax
      :formula="body"
      :safe="false"
    ></vue-mathjax>
  </div>
</template>
<script>
import { VueMathjax } from 'vue-mathjax'
import hljs from 'highlight.js'
window.hljs = hljs

export default{
  name: 'HtmlContent',
  components: {
    'vue-mathjax': VueMathjax,
  },

  props: {
    body: {
      type: String,
      default: '',
    },
  },

  data(){
    return {
    }
  },

  computed: {
  },

  mounted() {
    window.hljs.highlightAll()
  },

  methods: {
  },
}
</script>
<style>
@import "~highlight.js/styles/atom-one-dark.css";

.content-block {
  @import "@/scss/browser-default.scss";
}
</style>

